import { render, staticRenderFns } from "./DialogNotification.vue?vue&type=template&id=3d2e9d82&scoped=true"
import script from "./DialogNotification.vue?vue&type=script&lang=js"
export * from "./DialogNotification.vue?vue&type=script&lang=js"
import style0 from "./DialogNotification.vue?vue&type=style&index=0&id=3d2e9d82&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e9d82",
  null
  
)

export default component.exports